import { PriceIndexEnum } from 'api';

import { SelectField } from '../SelectField/SelectField';

const getIndexes = (): { label: string; value: string }[] => {
  const labels = {
    LME: 'London Metal Exchange (LME)',
    LME_MWP: 'London Metal Exchange & US Midwest (Platts)',
  };

  return Object.keys(PriceIndexEnum).map((key) => {
    return { label: labels[key as keyof typeof labels] || key, value: key };
  });
};

export const PriceIndexField = ({
  label,
  name,
  size,
  fullWidth = true,
}: {
  label: string;
  name: string;
  fullWidth?: boolean;
  size?: 'small' | 'medium';
}) => {
  return <SelectField label={label} options={getIndexes()} name={name} size={size} fullWidth={fullWidth} />;
};
